import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalisationService } from '../services/localisation.service';
import { TrgButtonComponent } from './TrgButton.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    TrgButtonComponent,
  ],
  declarations: [
    TrgButtonComponent,
  ],
  providers: [
    LocalisationService
  ]
})
export class UIModule {
}
